import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch, connect, ConnectedProps } from 'react-redux';
import { TenantActions } from 'Store/Tenant/Tenant.actions';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { IChangeContextData } from 'Data/interfaces/Tenant/IChangeContextData';
import { Http } from 'Utils/Http';

const ChangeContext: FC<Props> = () => {
  const dispatch = useDispatch();
  const params = useParams();

  const [redirectUrl] = useState(Http.GetQueryParams('redirectUrl'));

  useEffect(() => {
    if (params.tenantId) {
      const request = {
        tenantId: Number(params.tenantId),
        redirectUrl: redirectUrl ?? '/obras'
      } as IChangeContextData;

      dispatch(TenantActions.changeContext(request));
    }
  }, [dispatch, params.tenantId]);

  return (<></>);
};

const mapState = (state: IGlobalReducerState) => ({
  ...state.auth,
});

const connector = connect(
  mapState,
);

type Props = ConnectedProps<typeof connector>;

export default connector(ChangeContext);
